// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.snt-color-picker.v-btn[data-v-5b984fe3] {\n  border: 1px solid #e0e0e0 !important;\n  min-width: 48px;\n}\n", ""]);
// Exports
module.exports = exports;
